import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-5",
  "use": "foquz-icon-rating-5-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" id=\"foquz-icon-rating-5\"><path d=\"M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11z\" fill=\"#3ECE67\" /><path d=\"M9.073 8.554a2.5 2.5 0 00-3.535-.026m10.934.026a2.5 2.5 0 00-3.535-.026m1.708 5.905a5.001 5.001 0 01-7.071.052\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol